module.exports = __webpack_public_path__ + "static/media/Ugo.318bd768.jpg";